export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverUrl: string;
  description: string;
  categories: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  featured?: boolean;
  isNew?: boolean;
  isExclusive?: boolean;
}

export const categories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 128 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 96 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 85 },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', count: 64 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 72 },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line', count: 91 },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', count: 43 },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line', count: 56 },
];

const generateChapters = (comicId: string, count: number): ComicChapter[] => {
  const chapters: ComicChapter[] = [];
  for (let i = count; i >= 1; i--) {
    chapters.push({
      id: `${comicId}-ch-${i}`,
      title: i === count && count > 50 ? `第${i}话 最终章` : `第${i}话`,
      number: i,
      date: `2026-0${Math.ceil((count - i + 1) / 4)}-${String((((count - i) % 28) + 1)).padStart(2, '0')}`,
    });
  }
  return chapters;
};

export const comics: Comic[] = [
  {
    id: 'comic-1',
    slug: 'secret-romance',
    title: '秘密恋爱',
    author: '金智恩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%2C%20beautiful%20couple%20under%20cherry%20blossoms%2C%20soft%20warm%20lighting%2C%20pastel%20pink%20tones%2C%20minimalist%20background%2C%20clean%20illustration%20style%2C%20Korean%20webtoon%20art%2C%20romantic%20atmosphere%2C%20young%20adult%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '大学校园里一段不期而遇的恋情。计算机系的李雪和艺术系的韩俊熙因为一次偶然的图书馆邂逅，开启了他们之间微妙又甜蜜的故事。本作以细腻的画风和真实的情感描写著称，被誉为近年来最治愈的校园恋爱韩漫。',
    categories: ['romance', 'drama', 'daily'],
    status: '连载中',
    rating: 9.6,
    views: 2850000,
    chapters: generateChapters('comic-1', 78),
    featured: true,
  },
  {
    id: 'comic-2',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '朴志勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20art%2C%20magical%20academy%20setting%2C%20young%20wizard%20with%20glowing%20staff%2C%20mystical%20blue%20energy%2C%20dark%20background%20with%20stars%2C%20clean%20Korean%20webtoon%20illustration%20style%2C%20adventure%20theme&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '平凡高中生林浩在一次意外中发现自己拥有魔法天赋，被招入神秘的帝国魔法学院。在这里他结识了各色伙伴，也发现了隐藏在学院深处的巨大秘密。宏大的世界观、精彩的战斗场面，让你欲罢不能。',
    categories: ['fantasy', 'action'],
    status: '连载中',
    rating: 9.4,
    views: 2130000,
    chapters: generateChapters('comic-2', 102),
    isExclusive: true,
  },
  {
    id: 'comic-3',
    slug: 'city-hunter',
    title: '城市猎人',
    author: '李在勋',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%2C%20male%20protagonist%20in%20black%20suit%2C%20city%20night%20background%2C%20neon%20signs%2C%20mysterious%20atmosphere%2C%20clean%20sharp%20illustration%2C%20noir%20style%2C%20dark%20blue%20and%20red%20tones%2C%20professional%20webtoon%20art&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '前特种兵张泰浩回到首尔，成为一名私家侦探。白天他接手失踪案件，夜晚则化身都市义警，打击隐藏在霓虹灯下的罪恶。紧张刺激的剧情、拳拳到肉的格斗场面，让你感受硬核韩漫的魅力。',
    categories: ['action', 'thriller'],
    status: '连载中',
    rating: 9.3,
    views: 1980000,
    chapters: generateChapters('comic-3', 65),
  },
  {
    id: 'comic-4',
    slug: 'ghost-cafe',
    title: '幽灵咖啡馆',
    author: '崔秀英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20manhwa%20cover%2C%20cozy%20cafe%20interior%20with%20warm%20lighting%2C%20ghostly%20figure%20subtly%20present%2C%20young%20female%20protagonist%2C%20soft%20illustration%20style%2C%20mysterious%20warm%20tones%2C%20Korean%20webtoon%20aesthetic&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '失业女孩尹秀雅继承了一间位于小巷深处的老咖啡馆。这里不仅是喝咖啡的地方，更是连接生者与逝者的神秘空间。每一位来访的幽灵顾客都有未了的心愿，秀雅在帮助他们完成心愿的过程中，也逐渐找到了生命的意义。',
    categories: ['thriller', 'drama', 'daily'],
    status: '连载中',
    rating: 9.7,
    views: 3210000,
    chapters: generateChapters('comic-4', 56),
    featured: true,
    isNew: true,
  },
  {
    id: 'comic-5',
    slug: 'laugh-king',
    title: '搞笑天王',
    author: '金泰浩',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%2C%20funny%20male%20character%20with%20exaggerated%20expression%2C%20bright%20colorful%20background%2C%20playful%20illustration%20style%2C%20Korean%20webtoon%20art%2C%20light%20hearted%2C%20clean%20lines&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '梦想成为脱口秀演员的朴俊亨，每天都在各种奇葩事件中笑料百出。从相亲到面试，从家庭聚会到街头偶遇，他的生活简直是一部行走的喜剧。这部漫画被读者称为"减压神器"，每看必笑，根本停不下来。',
    categories: ['comedy', 'daily'],
    status: '连载中',
    rating: 9.2,
    views: 1560000,
    chapters: generateChapters('comic-5', 89),
  },
  {
    id: 'comic-6',
    slug: 'dark-mansion',
    title: '暗黑庄园',
    author: '韩智敏',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20cover%2C%20dark%20gothic%20mansion%20at%20night%2C%20mysterious%20atmosphere%2C%20full%20moon%2C%20silhouette%20of%20a%20figure%2C%20dark%20red%20and%20black%20tones%2C%20creepy%20elegant%20illustration%2C%20Korean%20webtoon%20horror%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '五位互不相识的人应邀来到一座深山庄园参加神秘游戏。奖金高达10亿韩元，但规则只有一个：活到最后的人获得一切。当第一个人离奇死亡后，他们才意识到这个游戏的真正恐怖之处。',
    categories: ['horror', 'thriller'],
    status: '已完结',
    rating: 9.5,
    views: 2450000,
    chapters: generateChapters('comic-6', 48),
    featured: true,
  },
  {
    id: 'comic-7',
    slug: 'spring-breeze',
    title: '春风十里',
    author: '张美英',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20manhwa%20cover%2C%20beautiful%20spring%20landscape%20with%20blossoms%2C%20young%20woman%20walking%20in%20park%2C%20soft%20pastel%20tone%2C%20warm%20sunlight%2C%20Korean%20webtoon%20illustration%2C%20emotional%20atmosphere%2C%20clean%20aesthetic&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '失去记忆的少女徐恩在春日里醒来，身边只有一个陌生男子自称是她的未婚夫。带着无数疑问，她开始尝试重新拼凑自己的过去。然而随着记忆一点点恢复，一个令人心碎的真相逐渐浮出水面。',
    categories: ['drama', 'romance'],
    status: '连载中',
    rating: 9.4,
    views: 1780000,
    chapters: generateChapters('comic-7', 72),
    isNew: true,
  },
  {
    id: 'comic-8',
    slug: 'office-survival',
    title: '职场生存记',
    author: '刘真雅',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20modern%20office%20setting%2C%20young%20female%20employee%20with%20laptop%2C%20clean%20corporate%20style%2C%20warm%20office%20lighting%2C%20Korean%20webtoon%20art%2C%20professional%20aesthetic%2C%20relatable%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '职场新人金雅英步入大公司后的搞笑又心酸的生存日记。从应付难缠上司到处理办公室政治，从加班地狱到团建尴尬，每一个故事都让打工人感同身受。韩国最火爆的职场题材漫画，没有之一！',
    categories: ['comedy', 'drama', 'daily'],
    status: '连载中',
    rating: 9.1,
    views: 1320000,
    chapters: generateChapters('comic-8', 95),
  },
  {
    id: 'comic-9',
    slug: 'dragon-hunter',
    title: '猎龙者',
    author: '孙贤宇',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20action%20manhwa%20cover%2C%20warrior%20facing%20dragon%2C%20epic%20battle%20scene%2C%20fiery%20background%2C%20heroic%20pose%2C%20dynamic%20illustration%2C%20Korean%20webtoon%20style%2C%20adventure%20fantasy%2C%20orange%20and%20red%20tones&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '在龙族肆虐的末日世界里，少年路辰继承了先祖的猎龙血脉。他从一个边陲小村的猎人，成长为对抗龙族暴政的传奇英雄。史诗般的冒险、炫目的战斗特效、深入人心的角色塑造，让你沉浸其中。',
    categories: ['fantasy', 'action'],
    status: '连载中',
    rating: 9.5,
    views: 2670000,
    chapters: generateChapters('comic-9', 86),
    featured: true,
  },
  {
    id: 'comic-10',
    slug: 'midnight-hospital',
    title: '午夜医院',
    author: '南宫敏',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%2C%20abandoned%20hospital%20interior%2C%20dark%20corridor%20with%20flickering%20light%2C%20mysterious%20nurse%20figure%2C%20creepy%20atmosphere%2C%20cold%20blue%20tones%2C%20Korean%20webtoon%20thriller%20art%2C%20suspenseful&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '实习医生安智慧被分配到了一家只在午夜营业的神秘医院。这里的病人得的不是普通疾病，而是被诅咒、附身和超自然力量困扰的受害者。每夜面对超乎想象的病例，智慧能否在保持理智的同时拯救患者？',
    categories: ['thriller', 'horror'],
    status: '连载中',
    rating: 9.3,
    views: 1890000,
    chapters: generateChapters('comic-10', 61),
    isExclusive: true,
    isNew: true,
  },
  {
    id: 'comic-11',
    slug: 'sweet-dreams',
    title: '甜蜜梦境',
    author: '郑恩智',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20romance%20fantasy%20manhwa%20cover%2C%20dreamy%20atmosphere%2C%20girl%20sleeping%20under%20star%20sky%2C%20soft%20purple%20and%20pink%20tones%2C%20magical%20elements%2C%20Korean%20webtoon%20illustration%2C%20romantic%20dreamlike%20scene%2C%20beautiful%20ethereal&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '少女素敏每晚入睡后都会进入同一个奇幻梦境世界，在那里她遇见了梦中的王子。但当梦境开始侵入现实，她发现梦境和现实之间的界限变得模糊。一段跨越梦境与现实的浪漫爱情故事。',
    categories: ['romance', 'fantasy'],
    status: '已完结',
    rating: 9.6,
    views: 2980000,
    chapters: generateChapters('comic-11', 55),
  },
  {
    id: 'comic-12',
    slug: 'sports-spirit',
    title: '运动之魂',
    author: '文俊赫',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20sports%20manhwa%20cover%2C%20young%20athlete%20running%20on%20track%2C%20dynamic%20motion%2C%20stadium%20background%2C%20sunset%20lighting%2C%20inspirational%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20energetic%20clean%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '天生患有腿疾的姜民浩凭借超乎常人的意志力，从康复训练走到全国田径锦标赛的赛场。一路上有泪水有汗水，更有无数鼓舞人心的瞬间。这部漫画激励了无数读者追逐自己的梦想。',
    categories: ['drama', 'action'],
    status: '已完结',
    rating: 9.7,
    views: 3450000,
    chapters: generateChapters('comic-12', 70),
    featured: true,
  },
];

export const featuredComics = comics.filter((c) => c.featured);
export const newComics = comics.filter((c) => c.isNew);
export const exclusiveComics = comics.filter((c) => c.isExclusive);
export const completedComics = comics.filter((c) => c.status === '已完结');